var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96941 0C4.46357 0 0 4.46345 0 9.96929C0 15.4754 4.46357 19.9385 9.96941 19.9385C15.4758 19.9385 19.9389 15.4754 19.9389 9.96929C19.9389 4.46381 15.4758 0.000476188 9.96929 0.000476188L9.96941 0ZM14.5413 14.3786C14.3627 14.6714 13.9794 14.7643 13.6865 14.5845C11.3458 13.1548 8.39917 12.831 4.92893 13.6238C4.59452 13.7 4.26119 13.4905 4.185 13.156C4.10845 12.8214 4.31714 12.4881 4.65238 12.4119C8.45 11.5439 11.7075 11.9179 14.3354 13.5238C14.6282 13.7036 14.7211 14.0857 14.5413 14.3786ZM15.7615 11.6637C15.5365 12.0298 15.058 12.1452 14.6925 11.9202C12.0127 10.2727 7.92786 9.79571 4.75821 10.7579C4.34714 10.882 3.91298 10.6504 3.78821 10.24C3.6644 9.82893 3.89619 9.3956 4.30655 9.2706C7.92714 8.17202 12.4282 8.70417 15.5056 10.5952C15.8711 10.8202 15.9865 11.2987 15.7615 11.6637ZM15.8663 8.83702C12.6532 6.92857 7.35202 6.7531 4.28429 7.68417C3.79167 7.83357 3.27071 7.55548 3.12143 7.06286C2.97214 6.57 3.25 6.04941 3.74298 5.89964C7.26452 4.8306 13.1187 5.03714 16.818 7.23321C17.262 7.49619 17.4073 8.06845 17.1442 8.51095C16.8823 8.95405 16.3085 9.10012 15.8668 8.83702H15.8663Z",
    fill: "#1ED760"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.b88ad9adea5056b0cb2233bd620a7ff6.svg";
export { ForwardRef as ReactComponent };